<template>
    <footer class="footer">
        <div class="container">
            <div class="footer__wrapper">
                <div class="row hide-me--tablet">
                    <div class="col-default-3 col-desktop-2 col-mobile-12">
                        <div class="footer__logo">
                            <z-logo :site-dir="`/${this.$root.lang}/`" :lang="`${this.$root.lang}`" :is-index="isIndex" />
                        </div>
                        <z-copyright
                            year-current
                            :text="this.$root.lang !== 'en' ? 'ООО «ТК МС-Трейд»' : 'TC MS-Trade'"
                        ></z-copyright>
                    </div>
                    <div class="col-default-5 col-mobile-12">
                        <navigation-footer :data="footerNavData" />
                        <navigation-footer :data="[
                            {
                                name: this.$root.lang !== 'en' ? 'Условия использования' : 'Terms of use',
                                link: `/${this.$root.lang}/terms`
                            },
                            {
                                name: this.$root.lang !== 'en' ? 'Карта сайта' : 'Site Map',
                                link: `/${this.$root.lang}/sitemap`
                            }
                        ]" />
                    </div>
                    <div class="col-default-4 col-desktop-5 col-mobile-12">
                        <p class="footer__text" v-html="text.adress"></p>
                        <div class="u-flex">
                            <span class="u-inline footer__text u-right-margin--m">{{ text.phone }} <z-link class="u-nowrap-text" href="tel:+74999578659">+7(499) 957-86-59</z-link></span>
                            <span class="u-inline footer__text">Email: <z-link class="u-nowrap-text" href="mailto:sales@tcmstrade.ru">sales@tcmstrade.ru</z-link></span>
                        </div>
                    </div>
                </div>
                <z-copyright
                    year-current
                    :text="this.$root.lang !== 'en' ? 'ООО «ТК МС-Трейд»' : 'TC MS-Trade'"
                    class="hide-me--default show-me--tablet"
                ></z-copyright>
            </div>
        </div>
    </footer>
</template>

<script>
import { localize } from '@/utils/i18n'
import NavigationFooter from '@/components/NavigationFooter'

export default {
    name: 'footer-layout',
    components: {
        NavigationFooter
    },
    data () {
        return {
            footerNavData: this.$root.app.components.navigation.top,
            text: {
                phone: localize({
                    ru: 'Телефон:',
                    en: 'Phone:'
                }),
                adress: localize({
                    ru: 'Адрес: 143401, Московская область, г.&nbsp;Красногорск, бульвар Строителей, д.&nbsp;4, корп.&nbsp;1, помещение&nbsp;IХ',
                    en: 'Adress: 143401, Krasnogorsk, 4&nbsp;Stroiteley Blvd, Bldg&nbsp;1, room&nbsp;IX'
                })
            }
        }
    },
    computed: {
        isIndex () {
            const indexPathname = window.location.pathname
            if (indexPathname === '/ru/' || indexPathname === '/en/') return true
        }
    }
}
</script>

<style lang="scss">
.footer {
    &__logo {
        flex-shrink: 0;
        margin-bottom: $token-spacers-xs;
        margin-top: -24px;

        .z-logo__img {
            width: auto;
            height: 70px;

            @include breakpoint (laptop) {
                height: 60px;
            }

            @include breakpoint (tablet) {
                height: 50px;
            }

            @include breakpoint (v-tablet) {
                height: 48px;
            }
        }
    }

    &__wrapper {
        border-top: 2px solid $token-colors-black-10;
        padding-top: 56px;
        padding-bottom: 24px;

        @include breakpoint (tablet) {
            padding-top: 20px;
            padding-bottom: 20px;
        }
    }

    &__item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-width: 530px;

        & + & {
            margin-left: $token-spacers-s;
        }

        @include breakpoint (laptop) {
            &:first-child {
                max-width: 180px;
            }
        }

        @include breakpoint (tablet) {
            display: none;
        }

        .z-link {
            color: $token-colors-link-dark-default;
            border-bottom: 1px solid;
            font-size: 14px;
        }
    }

    &__text {
        font-size: 14px;
        font-weight: 400;
        color: $token-colors-black-80;
    }
}
</style>
